import { Component } from '@angular/core';
import {RouterOutlet} from '@angular/router';

@Component({
  selector: 'app-layout-public',
  imports: [
    RouterOutlet
  ],
  templateUrl: './layout-public.component.html',
  styleUrl: "./layout-public.component.scss",
  host: { class: 'bg-background text-foreground block min-h-svh' },
})
export class LayoutPublicComponent {

}
